import React from 'react';
import { Formik } from 'formik';

import { FormInput } from 'Shared/components/FormInput';
import { ClearFilterButton } from 'Shared/components/ClearFilterButtons';

import styles from './styles.module.css';
import { useFilters } from 'Admin/Partners/hooks/useFilters';

export type FilterType = {
  name?: string;
  employerIdentificationNumber?: string;
  nationalProducerNumber?: string;
};

const ALLOWED_FILTERS: Array<keyof FilterType> = [
  'name',
  'employerIdentificationNumber',
  'nationalProducerNumber',
];

export const PartnerFilters: React.FC<{
  filters: FilterType;
  onChangeFilters(filters: FilterType): void;
}> = ({ filters, onChangeFilters }) => {
  const { updateFilters, clearAllFilters } = useFilters<FilterType>({
    allowedFilters: ALLOWED_FILTERS,
    onChangeFilters,
  });

  return (
    <Formik enableReinitialize initialValues={filters} onSubmit={updateFilters}>
      {({ handleSubmit, values, handleChange }) => {
        return (
          <form
            onSubmit={handleSubmit}
            className={styles.search}
            data-testid="form"
          >
            <FormInput
              name="name"
              className={styles.searchInput}
              value={values.name || ''}
              label="Search name"
              variant="search"
              onChange={handleChange}
              onIconClick={() => {
                handleSubmit();
              }}
            />
            <FormInput
              name="employerIdentificationNumber"
              className={styles.searchInput}
              value={values.employerIdentificationNumber || ''}
              label="Search EIN"
              variant="search"
              onChange={handleChange}
              onIconClick={() => {
                handleSubmit();
              }}
            />
            <FormInput
              name="nationalProducerNumber"
              className={styles.searchInput}
              value={values.nationalProducerNumber || ''}
              label="Search NPN"
              variant="search"
              onChange={handleChange}
              onIconClick={() => {
                handleSubmit();
              }}
            />
            <button
              data-testid="filter-submit"
              type="submit"
              className={styles.submit}
            />
            <div className={styles.clearContainer}>
              <ClearFilterButton
                onClick={clearAllFilters}
                disabled={!Object.keys(filters).length}
                data-testid="clear-filters"
              >
                Clear Search
              </ClearFilterButton>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};
